import styled from 'styled-components';
import { breakpoints, colorCSS, cssColorsFromBackgroundField, radius } from '../../styles';
export const Block = styled.div `
  ${({ appearance }) => appearance !== 'No Padding' &&
    `padding: 1.5rem 3rem;
        @media (max-width: ${breakpoints.sm}px) {
          padding: 7% 10%;
        }`}
  ${({ fullHeight }) => fullHeight && 'height: 100%;'}  
  ${({ border, borderColor }) => border &&
    borderColor &&
    `
    border: 1px solid ${borderColor};
    padding: 1.5rem;
    `}
  ${({ appearance, headingColor, background, roundedCorners }) => {
    switch (appearance) {
        case 'Highlighted':
            return `
          text-align: left;
          padding: 1.5rem 2.2rem;
          h5 {
            color: ${headingColor};
          }
          p {
            margin: 0.5rem 0;
          }
          ul {
            padding: 0 0 0 1.4rem;
            columns: 2;
          }
          li {
            margin: 0 1rem 1rem 0;
          }
          @media (max-width: ${breakpoints.sm}px) {
            ul {
              columns: 1;
            }
          }
        `;
        case 'Neutral Border':
            return `border: 1px solid ${colorCSS('N60')};`;
        case 'Speech Bubble Left':
            return `
          border-radius: ${radius['medium']};
          margin-bottom: 2rem;
          margin-right: auto;
          width: max-content;
          max-width: 70%;
          text-align: left;
          font-weight: 300;
          padding: 1rem 1.7rem;
          ::after {
            content: '';
            width: 0;
            display: block;
            position: absolute;
            margin-top: 0.8rem;
            border-left: 1rem solid ${background};
            border-right: 0.5rem solid transparent;
            border-top: 0.5rem solid ${background};
            border-bottom: 1rem solid transparent;
          }
          @media (max-width: ${breakpoints.sm}px) {
            min-width: 100%;
            margin-right: 0;
            padding: 1rem 1rem 1rem 1.5rem;
          }
        `;
        case 'Speech Bubble Right':
            return `
          border-radius: ${radius['medium']};
          margin-bottom: 2rem;
          margin-left: auto;
          width: max-content;
          max-width: 70%;
          text-align: right;
          font-weight: 300;
          padding: 1rem 1.7rem;
          ::after {
            content: '';
            width: 0;
            display: block;
            position: absolute;
            margin-top: 0.8rem;
            border-left: 0.5rem solid transparent;
            border-right: 1rem solid ${background};
            border-top: 0.5rem solid ${background};
            border-bottom: 1rem solid transparent;
            right: 2.5rem;
          }
          @media (max-width: ${breakpoints.sm}px) {
            min-width: 100%;
            margin-left: 0;
            padding: 1rem 1.5rem 1rem 1rem;
          }
        `;
        case 'Top Blue Stripe':
            return `
          padding-top: 3rem !important;
          position: relative;
          &:before {
            background: linear-gradient(
              135deg,
              ${colorCSS('P300')} 0%,
              ${colorCSS('B300')} 50%,
              ${colorCSS('T300')} 100%
            );
            content: '';
            height: 1.5rem;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
            ${roundedCorners &&
                `border-radius: ${radius[roundedCorners.toLowerCase()]} ${radius[roundedCorners.toLowerCase()]} 0 0;`}
          }
        `;
        default:
            return '';
    }
}}
  ${({ backgroundField }) => cssColorsFromBackgroundField(backgroundField)}
  ${({ roundedCorners }) => roundedCorners &&
    `
      border-radius: ${radius[roundedCorners.toLowerCase()]};
      overflow: hidden;
    `}
  ${({ shadow }) => shadow && `box-shadow: 0 0 1rem ${colorCSS('N900', 0.25)};`}

  input,
  textarea, select {
    background: ${colorCSS('N0')} !important;
  }

  h3 {
    border: none !important;
  }

  .mktoButton {
    margin-bottom: 0 !important;
  }
  > * {
    flex-grow: 1;
  }
  *:last-child {
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=UiBlock.styles.js.map